import styled, { css } from 'styled-components';
import { CHECKBOX_TICK_SVG } from '@constants';
import { CheckboxDesign } from '@contracts';
import Colors from './Colors';

interface IProps {
  $mods?: Array<string | number>;
  $mobileMods?: Array<string | number>;
}

interface IFigmaProps {
  $bold?: boolean;
  $uppercase?: boolean;
}

export const P = styled.p<IProps>`
  font-size: 28.8px;
  line-height: 1.6;
  font-family: 'BrownStd';
  color: #003a1b;

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

// Used in e.g. account page
export const P1 = styled.p<IProps>`
  font-size: 25.6px;
  line-height: 1.6;
  font-family: 'BrownStd';
  color: #003a1b;

  /* @media only screen and (max-width: 768px) {
    font-size: 25.6px;
  } */

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};
  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

export const P2 = styled.p<IProps>`
  font-size: 22.4px;
  line-height: 1.4;
  font-family: 'BrownStd';
  color: #003a1b;

  @media only screen and (max-width: 768px) {
    font-size: 19.2px;
  }

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};
  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

// used in order status in account page / orders
export const P3 = styled.p<IProps>`
  font-size: 19.2px;
  line-height: 1.4;
  font-family: 'BrownStd';
  color: #003a1b;

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};
  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

export const H = styled.h1<IProps>`
  font-size: 48px;
  font-family: 'Domaine';
  color: #003b1b;
  line-height: 1.25;
  font-weight: normal;

  /* feel free to change */
  @media only screen and (max-width: 768px) {
    font-size: 2.2em;
  }

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

export const Span = styled.span<IProps>`
  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

export const A = styled.a<IProps>`
  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

export const H1 = styled.h1<IProps>`
  font-size: 72px;
  font-family: 'Domaine';
  color: #003b1b;
  line-height: 1.25;
  font-weight: normal;

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

export const H2 = styled.h2<IProps>`
  font-size: 56px;
  font-family: 'Domaine';
  color: #003b1b;
  line-height: 1.25;
  font-weight: normal;

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

// Used e.g. headings on Checkout
export const H3 = styled.h3<IProps>`
  font-size: 51.2px;
  font-family: 'Domaine';
  color: #003b1b;
  line-height: 1.25;
  font-weight: normal;

  @media only screen and (max-width: 768px) {
    font-size: 2.6em;
  }

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

export const H4 = styled.h4<IProps>`
  font-size: 51.2px;
  font-family: 'BrownStd';
  color: #003b1b;
  line-height: 1.25;
  font-weight: 500;

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

export const H5 = styled.h4<IProps>`
  font-size: 38.4px;
  font-family: 'BrownStd';
  color: #003b1b;
  line-height: 1.6;
  font-weight: 500;

  ${(props) => (props.$mods ? modifiers(props.$mods) : '')};

  @media only screen and (max-width: 768px) {
    ${(props) => (props.$mobileMods ? modifiers(props.$mobileMods) : '')};
  }
`;

function modifiers(arr: any) {
  let str = ``;

  arr.forEach((mod: string | number) => {
    // adjust font size with any number
    if (typeof mod === 'number') {
      str += `font-size: ${mod / 10}em;`;
      return;
    }

    if (mod === 'center') {
      str += 'text-align: center;';
      return;
    }

    if (mod === 'left') {
      str += 'text-align: left;';
      return;
    }

    if (mod === 'right') {
      str += 'text-align: right;';
      return;
    }

    if (mod === 'white') {
      str += 'color: #FEFCE8;';
      return;
    }

    if (mod === 'default-color') {
      str += 'color: #003a1b;';
      return;
    }
    if (mod === 'gold') {
      str += 'color: #EDA91F;';
      return;
    }

    if (mod === 'gold2') {
      str += 'color: #e4ac43;';
      return;
    }

    if (mod === 'error') {
      str += `
        color: #ea534f;
        font-size: 16px;
      `;
      return;
    }

    if (mod === 'orange') {
      str += `
        color: #F0A740;
      `;
      return;
    }

    if (mod === 'fade') {
      str += `
        opacity: 0.6;
      `;
      return;
    }

    if (mod === 'bold') {
      str += 'font-weight: bold;';
      return;
    }

    if (mod === 'regular') {
      str += 'font-weight: regular;';
      return;
    }

    if (mod === 'caps') {
      str += 'text-transform: uppercase;';
      return;
    }

    if (mod === 'spaced') {
      str += 'letter-spacing: 2px;';
      return;
    }

    if (mod === 'spaced1') {
      str += 'letter-spacing: 1px;';
      return;
    }

    if (mod === 'spaced0') {
      str += 'letter-spacing: default;';
      return;
    }

    if (mod === 'hover') {
      str += `&:hover {
        cursor: pointer;
      }`;
      return;
    }

    if (mod === 'strike') {
      str += `text-decoration: line-through;`;
      return;
    }

    if (mod === 'link') {
      str += `
        text-decoration: underline;
        font-weight: bold;
        &:hover {
          cursor: pointer;
        }
      `;
      return;
    }

    if (mod === 'link2') {
      str += `
        text-decoration: underline;
        font-weight: bold;
        &:hover {
          cursor: pointer;
        }
      `;
      return;
    }

    throw Error(`Unknown modifier '${mod}' passed to Typography.js`);
  });

  return css`
    ${str}
  `;
}

export const InputLabel = styled(P)`
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  color: inherit;
  margin-bottom: 5px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const InputDescription = styled.div`
  color: inherit;

  p {
    font-family: 'BrownStd';
    color: inherit;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: inherit;
    margin-bottom: 10px;

    @media (max-width: 768px) {
      font-size: 13px;
    }
  }
`;

export const CustomCheckbox = styled.div<{ $checked: boolean; $design?: CheckboxDesign }>`
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 2px solid ${Colors.navyBlue};
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) => {
    switch (props.$design) {
      case CheckboxDesign.PinkHighlight:
        return css`
          ${props.$checked &&
          css`
            border-color: ${Colors.lilac};

            &:after {
              content: ' ';
              display: block;
              width: 11px;
              height: 11px;
              background-image: url(${CHECKBOX_TICK_SVG});
              background-repeat: no-repeat;
              background-position: center;
            }
          `}
        `;
      default:
        return css`
          ${props.$checked &&
          css`
            &:after {
              content: ' ';
              display: block;
              width: 11px;
              height: 11px;
              background-image: url(${CHECKBOX_TICK_SVG});
              background-repeat: no-repeat;
              background-position: center;
            }
          `}
        `;
    }
  }}
`;

export const SFDHeading1SFMHeading2 = styled.div<IFigmaProps>`
  color: ${Colors.navyBlue};
  font-family: Domaine;
  font-size: 50px;
  font-style: normal;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.5px;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 120%;
    letter-spacing: -0.48px;
  }
`;

export const SFMHeading2 = styled.div<IFigmaProps>`
  color: ${Colors.navyBlue};
  font-family: Domaine;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.48px;
`;

export const SFMHeading3 = styled.div<IFigmaProps>`
  font-family: Domaine;
  color: ${Colors.navyBlue};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
`;

export const SFDHeading2 = styled.div<IFigmaProps>`
  font-family: Domaine;
  color: ${Colors.navyBlue};
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;

  @media (max-width: 768px) {
    font-family: Domaine;
    font-size: 24px;
    line-height: 120%;
    letter-spacing: -0.48px;
  }
`;

export const SFDHeading2SFMHeading3 = styled.div<IFigmaProps>`
  font-family: Domaine;
  color: ${Colors.navyBlue};
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;

  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
  }
`;

export const SFDHeading4 = styled.div<IFigmaProps>`
  color: ${Colors.navyBlue};
  font-family: Domaine;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 130%;
    letter-spacing: -0.32px;
  }
`;

export const SFDHeading6 = styled.div<IFigmaProps>`
  color: ${Colors.navyBlue};
  font-family: 'BrownStd';
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 138.462% */
  letter-spacing: 1.5px;
  text-transform: uppercase;
`;

export const SFMBodyMD = styled.p<IFigmaProps>`
  font-family: BrownStd;
  color: ${Colors.navyBlue};
  font-size: 13px;
  font-style: normal;
  line-height: 150%;
  font-weight: ${({ $bold }) => ($bold ? '700' : '400')};
`;

export const SFMBodyLG = styled.p<IFigmaProps>`
  font-family: BrownStd;
  color: ${Colors.navyBlue};
  font-size: 16px;
  font-style: normal;
  line-height: 150%;
  font-weight: ${({ $bold }) => ($bold ? '700' : '400')};
`;

export const SFDBodyMD = styled.p<IFigmaProps>`
  color: ${Colors.navyBlue};
  font-family: BrownStd;
  font-size: 16px;
  font-style: normal;
  line-height: 150%
  font-weight: ${({ $bold }) => ($bold ? '700' : '400')};
  ${({ $uppercase }) => ($uppercase ? 'text-transform: uppercase;' : '')}


  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const SFDBodyMDSFMBodyLG = styled.p<IFigmaProps>`
  color: ${Colors.navyBlue};
  font-family: BrownStd;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const SFDBodyLG = styled.p<IFigmaProps>`
  color: ${Colors.navyBlue};
  font-family: BrownStd;
  font-size: 18px;
  font-style: normal;
  line-height: 150%;
  font-weight: ${({ $bold }) => ($bold ? '700' : '400')};

  @media (max-width: 768px) {
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
  }
`;

export const SFDBodyLGSFMBodyMD = styled.p<IFigmaProps>`
  color: ${Colors.navyBlue};
  font-family: BrownStd;
  font-size: 18px;
  font-weight: 400;
  font-style: normal;
  line-height: 150%;

  @media (max-width: 768px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
`;
